<svelte:options customElement="hb-input-text" />

<script lang="ts">
  import type { Component } from "./types/webcomponent.type";
  import {
    parseSchemaentryProp,
    sameSetValPayload,
    schemaentryFingerprint,
    shouldApplySchemaSync,
  } from "../lib/schemaentry";

  let { schemaentry, show_validation = "no" }: Component = $props();

  let field = $state<Record<string, any> | null>(null);
  let schemaFingerprint = $state("");

  let value: string = $state("");
  let regex = $derived.by(() => {
    if (field?.validationRegex) {
      return new RegExp(field.validationRegex);
    }
    return undefined;
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  let min: number = $derived.by(() => {
    return field?.params?.min || field?.params?.min === 0
      ? field.params.min
      : 0;
  });
  let max: number = $derived.by(() => {
    return field?.params?.max || field?.params?.max === 0
      ? field.params.max
      : 10000;
  });
  let valid = $derived.by(() => {
    if (field) {
      if (field.required) {
        if (value) {
          if (regex && !regex.test(value)) {
            return false;
          } else if (min && !(value.length >= min)) {
            return false;
          } else if (max && value && !(value.length <= max)) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  });

  $effect(() => {
    const fp = schemaentryFingerprint(schemaentry);
    const nextField = parseSchemaentryProp(schemaentry);
    if (!nextField) {
      field = null;
      return;
    }
    if (shouldApplySchemaSync(fp, () => schemaFingerprint)) {
      schemaFingerprint = fp;
      field = nextField;
      if (nextField.value !== undefined && nextField.value !== null) {
        value = String(nextField.value);
      } else {
        value = "";
      }
    }
  });

  let lastSetVal = $state<{
    value: unknown;
    valid: boolean;
    id: string | undefined;
  } | null>(null);

  $effect(() => {
    const f = field;
    if (!f?.id) return;
    const payload = { value, valid, id: f.id as string | undefined };
    if (sameSetValPayload(lastSetVal, payload)) return;
    lastSetVal = payload;
    dispatch("setVal", { value, valid, id: f.id });
  });
</script>

{#if field != null}
  <div class="field">
    <div class="control">
      <input
        bind:value
        type="text"
        class="input"
        class:is-success={show_validation === "yes" &&
          !!field?.required &&
          valid}
        class:is-danger={show_validation === "yes" &&
          !!field?.required &&
          !valid}
        id={field?.id}
        required={field?.required}
        placeholder={field?.placeholder}
        readonly={field?.readonly}
        disabled={!!field?.disabled}
        onkeypress={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            dispatch("clickEnter", { value, valid, id: field?.id });
          }
        }}
      />
    </div>

    {#if field?.validationTip && show_validation === "yes" && !valid}
      <p part="invalid-feedback" class="help is-danger">
        {field.validationTip}
      </p>
    {/if}
  </div>
{/if}

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
